import { useDebounce } from "../../../lib/hooks/debounce";
import { SearchIcon } from "../../../ui/icons/search";
import Input from "../../../ui/molecules/input";
import { SelectCustom } from "../../../ui/molecules/select";
import { FindAllUsersFilters, UserRole, UserRoleMap } from "../dto";

const options = [
  { value: UserRole.admin, label: UserRoleMap.get(UserRole.admin)! },
  {
    value: UserRole.collaborator,
    label: UserRoleMap.get(UserRole.collaborator)!,
  },
  { value: UserRole.commercial, label: UserRoleMap.get(UserRole.commercial)! },
  { value: UserRole.customer, label: UserRoleMap.get(UserRole.customer)! },
  {
    value: UserRole.team_leader,
    label: UserRoleMap.get(UserRole.team_leader)!,
  },
];

interface Props {
  filters: FindAllUsersFilters
  onChange: React.Dispatch<React.SetStateAction<FindAllUsersFilters>>
}

export function UsersFilters({ filters, onChange }: Props) {

  const debounce = useDebounce(
    (value) => onChange((f) => ({ ...f, search: value })),
    1000
  );

  return (
    <div
      className="px-4"
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px",
        width: "100%",
        flexShrink: 0,
        height: "64px",
      }}
    >
      <div style={{ width: "640px" }}>
        <Input
          startIcon={<SearchIcon color={""} size={0} />}
          placeholder="Cerca utente"
          onChangeText={(value) => debounce(value)}
          defaultValue={filters.search || ""}
        />
      </div>
      <div style={{ width: "320px" }}>
        <SelectCustom
          isClearable
          placeholder="Tutti i ruoli"
          options={options}
          onChange={(value) => onChange((f) => ({ ...f, role: value ? (value as UserRole) : undefined }))}
          defaultValue={filters.role}
        />
      </div>
    </div>
  );
}
